import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getCompanyById } from "../../store/selectors/selector.companies.jsx";

export const CompanyNameContainer = ({ id }) => {
  const { t } = useTranslation();
  const company = useSelector((state) => getCompanyById(state, id));
  return company ? company.name : t("No Company");
};

CompanyNameContainer.propTypes = {
  id: PropTypes.number.isRequired,
};
